module.exports = __webpack_public_path__ + "img/zsj.666371db.png";